module.exports = __webpack_public_path__ + "static/media/oneshelf-pic5.102b16ec.JPG";